/* Layout */
import {RouteConfig} from 'vue-router';
import Layout from '@/layout/index.vue';
import _ from "lodash";


const ProjectRouter: RouteConfig[] = [
  {
    path: '/summary_data',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      title: 'Сводные данные',
      icon: 'clipboard',
      roles: ['admin', 'operator'],
      alwaysShow: true
    },
    children: [
      {
        path: 'balance',
        component: () => import(/* webpackChunkName: "balance" */ '@/views/balance/index.vue'),
        name: 'balance',
        meta: {
          title: 'Физический баланс',
          icon: 'scales',
          roles: ['admin', 'operator']
        }
      },
      {
        path: 'coast_balance',
        component: () => import(/* webpackChunkName: "balance" */ '@/views/coast_balance/index.vue'),
        name: 'coast_balance',
        meta: {
          title: 'Стоимостной баланс',
          icon: 'scales',
          roles: ['admin', 'operator']
        }
      },
      {
        path: 'transport',
        component: () => import(/* webpackChunkName: "transport" */ '@/views/transport/index.vue'),
        name: 'transport',
        meta: {
          title: 'Транспорт',
          icon: 'tree',
          roles: ['admin', 'operator']
        }
      },
      {
        path: 'group_object_constructor',
        component: () => import(/* webpackChunkName: "blocks" */ '@/views/grouped-objects/index.vue'),
        name: 'group_object_constructor',
        meta: {
          title: 'Групповые объекты',
          icon: 'equipment',
          roles: ['admin', 'operator'],   // Для операторов без права просмотра чего-либо в объектах ссылка скрывается в меню
        }
      },
    ]
  },
  {
    path: '/tarifs',
    component: Layout,
    meta: {
      roles: ['admin', 'operator']
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "tarifs" */ '@/views/tarifs/index.vue'),
        name: 'tarifs',
        meta: {
          title: 'Тарифы',
          icon: 'rouble',
          roles: ['admin', 'operator']
        }
      },
    ]
  },
  {
    path: '/contragents',
    component: Layout,
    meta: {
      roles: ['admin', 'operator']
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "contragents" */ '@/views/contragents/index.vue'),
        name: 'contragents',
        meta: {
          title: 'Контрагенты',
          icon: 'education',
          roles: ['admin', 'operator']
        }
      },
    ]
  },
  {
    path: '/blocks',
    component: Layout,
    meta: {
      roles: ['admin']
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "blocks" */ '@/views/blocks/index.vue'),
        name: 'blocks',
        meta: {
          title: 'Объекты. Настройка блоков',
          icon: 'equipment',
          roles: ['admin'],
        }
      },
    ]
  },
  {
    path: '/settings',
    component: Layout,
    meta: {
      roles: ['admin']
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/index.vue'),
        name: 'settings',
        meta: {
          title: 'Администрирование и настройка',
          icon: 'gear',
          roles: ['admin'],
        }
      },
    ]
  },
  {
    path: '/control',
    component: Layout,
    meta: {
      roles: ['admin', 'operator'],
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "buy" */ '@/views/input-control/index.vue'),
        name: 'control',
        meta: {
          title: 'Контроль заполнения',
          icon: 'check',
          roles: ['admin', 'operator'],
        }
      },
    ]
  },

];

export default ProjectRouter;
